// Port of api/fuel/app/classes/insights/size/changes.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'
import Config from 'offline/model/config'

function excludeExpansions(ownerId) {
	var config = Config.user(ownerId)
	return !!(((config || {}).insights || {}).size || {}).expansions
}

export default Segment.extend({
	name: 'changes',
	types: [Constants.TYPE_USER],
	insight: ['changes.type'],
	detail: ['changes'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		if (!owner.get_count_collection()) return {}

		var exclude = excludeExpansions(vars && vars.sessionUserId)
		var changeType = (filter && filter['changes.type']) ? filter['changes.type'] : 'added'
		var changes = []
		var candidates = Util.queryFast(
			'SELECT l.game_id AS g, l.log_date AS d, g.game_name AS n,' +
			' COALESCE(SUM(p.play_count), 0) AS p, COALESCE(r.rating_value, "-") AS r' +
			' FROM (log_user_collection l LEFT JOIN play p ON p.game_id = l.game_id AND l.user_id = p.user_id)' +
			' LEFT JOIN rating r ON r.game_id = l.game_id AND r.user_id = l.user_id, game g' +
			' WHERE l.log_context = ' + (changeType === 'added' ? Constants.LOG_CONTEXT_ADDED : Constants.LOG_CONTEXT_REMOVED) +
			(exclude ? ' AND g.game_type = 1' : '') +
			' AND l.game_id = g.game_id' +
			' AND l.user_id = ' + owner.get_id() +
			' GROUP BY l.game_id ORDER BY l.log_date DESC, l.game_id ASC LIMIT 0, ' + (detail ? 100 : 5)
		)

		for (var i = 0; i < candidates.length; i++) {
			var candidate = candidates[i]
			var gameId = parseInt(candidate.g, 10)
			this._references.games.push(gameId)
			changes.push({
				id: gameId,
				date: parseInt(candidate.d, 10) || 0,
				game: {
					id: gameId,
					name: candidate.n
				},
				plays: parseInt(candidate.p, 10) || 0,
				rating: candidate.r === '-' ? '-' : (parseFloat(candidate.r) || 0)
			})
		}

		if (detail) {
			return {
				games: changes.map(function(change) {
					var game = { id: change.id }
					game[changeType] = change.date
					return game
				})
			}
		}

		return {
			changes: changes
		}
	}
})
